import { render, staticRenderFns } from "./BIDataReplicationDetailDialog.vue?vue&type=template&id=5fd2d40e&"
import script from "./BIDataReplicationDetailDialog.vue?vue&type=script&lang=js&"
export * from "./BIDataReplicationDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports